import { render, staticRenderFns } from "./OnRatiosAgencyInfo.vue?vue&type=template&id=79fae006&"
import script from "./OnRatiosAgencyInfo.vue?vue&type=script&lang=js&"
export * from "./OnRatiosAgencyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports